<template>
 <div class="box">
   <div style="text-align: center ;padding:2% ">
     <el-button type="primary" @click="isInput=false,isImg=!isImg,isVedio=false,show=false">上传轮播图</el-button>
     <el-button type="primary" @click="isInput=false,isImg=false,isVedio=!isVedio,show=false">上传视频</el-button>
     <el-button type="primary" @click="isInput=!isInput,isImg=false,isVedio=false,show=false">上传链接</el-button>
     <el-button type="primary" @click="show=!show,isInput=false,isImg=false,isVedio=false">上传word/pdf/excel/zip/rar/exe/md/ppt/mp4</el-button>
   </div>
   <el-upload
       class="upload-demo"
       drag
       action="/api3/FileUpload/addWordEtc"
       v-show="show"
       multiple
   >

     <el-icon class="el-icon--upload"><upload-filled /></el-icon>
     <div class="el-upload__text">
       <em>点击上传文件</em>
     </div>
     <template #tip>
       <div class="el-upload__tip">
         files with a size less than 1GB
       </div>
     </template>
   </el-upload>
<!--   上传友情链接-->
   <div v-if="isInput" style="padding-left: 28%">
     <el-form>
       <el-row>
         <el-col span="8">
           <el-form-item >

             <el-input v-model="name"  placeholder="友情链接名称:" ></el-input>
           </el-form-item>
         </el-col>
         &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp

         <el-col span="24">
           <el-form-item>
             <el-input v-model="friendurl"  placeholder="网址:"></el-input>
           </el-form-item>
         </el-col>
         &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
         <el-button type="primary" @click="addFriendUrl" style="text-align: right" >提交</el-button>

       </el-row>

     </el-form>

   </div>
   <div class="img-upload">
     <el-upload
         class="upload-demo"
         drag
         action="/api3/FileUpload/addImg"
         :on-success="uploadSuccess"
         multiple
         v-if="isImg"
     >
     <el-icon class="el-icon--upload"><upload-filled/></el-icon>
     <div class="el-upload__text">
       <em>点击上传图片</em>
     </div>
     <template #tip>
       <div class="el-upload__tip">
         为确保轮播图显示质量，请优先上传7800 × 2000以及类似比例的图片<br/>
         jpg/png files with a size less than 500kb
       </div>
     </template>
   </el-upload>
<!--   轮播图-->
      <div class="log_img" v-if="isImg &&imges.length>0">

       <el-carousel :interval="2500" height="350px">
         <el-carousel-item v-for="(item,index) in imges" :key="index">
           <img :src="item" style="max-height:100%;max-width:100% ">
         </el-carousel-item>
       </el-carousel>
     </div>
   </div>

   <el-upload
       class="upload-demo"
       drag
       action="/api3/FileUpload/addVedio"

       multiple
       v-if="isVedio"
   >

     <el-icon class="el-icon--upload"><upload-filled /></el-icon>
     <div class="el-upload__text">
       <em>点击上传视频</em>
     </div>
     <template #tip>
       <div class="el-upload__tip">
         vedio files with a size less than 500MB
       </div>
     </template>
   </el-upload>
 </div>
</template>

<script  >
import time from "@/core/time";
const Base64 = require('js-base64').Base64
export default {
  name: "FileEdit",
  data(){
    return {
      show:false,
      isImg:false,
      isVedio:false,
      friendurl:'',
      isInput:false,
      name:'',
      fileType:'',
      mode: {},
      modeList: [],
      dialogOfUpload: false,
      fileList: [],
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      imges: [

      ],
    }
  },
  created() {
    this.getCarouselChart();//获取轮播图图片
  },
  mounted() {
  },
  methods:{
    uploadSuccess(response, file, fileList) {
      // console.log(response);
      this.getCarouselChart();
      // //debugger
    },
      //获取轮播图片
    getCarouselChart(){
      this.$request.post('/FileUpload/getCarouselChart',).then(res=>{
        console.log('+++++++++++++',res)
        this.imges=res.obj;

        for(let i=0;i<this.imges.length;i++){
          console.log('============',window.location)
          this.imges[i]=window.location.origin+'/api3/'+this.imges[i];
          // console.log(this.imges[i])
        }
        console.log('============',this.imges)
      })
    },
    addFriendUrl(){
      let data={
        friendurl:this.friendurl,
        name:this.name,
        fileType:'l'
      }
      this.$request.post('/FileUpload/addFridendUrl',data).then(res=>{

      })
      this.isInput=false
      location.reload();
    },
    editPage(value){
      this.$router.push({
        path:'/requirementEdit',
        query:{
          id:value.id,

        }
      })
    },

  }
}
</script>

<style scoped lang="less">
  .box{
    height: 100%;
    padding:2% 20%;
    text-align: center;
    .log_img {
      width: 100%;
      //height: 100%;
      // display: inline-block;
      vertical-align: middle;
      margin-right: 20px;
      margin-top: 35px;
      text-align: -webkit-center;
      //float: left;

      .el-carousel__container {
        width: 100%;
        height: 100%;
      }

      img:hover {
        cursor: pointer;
      }
    }
  }
</style>
